export default "__VITE_ASSET__HgR9gAsL__"